import PropTypes from "prop-types";

export const propTypes = {
  applyColumnsAfterFilter: PropTypes.bool,
  colHeaders: PropTypes.any,
  columns: PropTypes.array,
  columnSorting: PropTypes.bool,
  colWidths: PropTypes.any,
  customRenderer: PropTypes.func,
  data: PropTypes.array,
  dropdownMenu: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  filters: PropTypes.bool,
  fixedRowsBottom: PropTypes.number,
  fragmentSelection: PropTypes.bool,
  headerInfo: PropTypes.any,
  height: PropTypes.any,
  labelInfo: PropTypes.string,
  nestedRows: PropTypes.bool,
  rowHeaders: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  showCloseWindowButton: PropTypes.bool,
  showExportFileButton: PropTypes.bool,
  showViewAllDataButton: PropTypes.bool,
  showViewAllDataUrl: PropTypes.string,
  showSharedMembersDataButton: PropTypes.bool,
  showSharedMembersUrl: PropTypes.string,
  hideSharedMembersDataButton: PropTypes.bool,
  hideSharedMembersUrl: PropTypes.string,
  stretchH: PropTypes.string,
  width: PropTypes.number,
  wordWrap: PropTypes.bool,
  calculateTotals: PropTypes.bool,
  manualColumnResize: PropTypes.bool,
  firstColWidth: PropTypes.number
};
